// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ValidatePriceBreaks,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdatePriceBreakPrice";
import validatePriceBreaks from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/ValidatePriceBreaks";

export const XngValidatePriceBreaks: any = async (props: any) => {
    const isValid = await makeHandlerChainAwaitable(validatePriceBreaks)({
        isFixedQty: props.parameter.isFixedQty,
        minQty: props.parameter.minQty,
    })(props.dispatch, props.getState);
    if (!isValid) {
        return false;
    }
};

replaceInChain(chain, ValidatePriceBreaks, XngValidatePriceBreaks);
